import type { ColumnOrderState } from '../hooks/useTable';

export function getMergedColumnOrder(
  order: ColumnOrderState,
  availableColumns: { key: string }[]
): ColumnOrderState {
  const currentColumnKeys = availableColumns.map(column => column.key);
  const currentColumnKeySet = new Set(currentColumnKeys);
  const validSavedColumnOrder = (order || []).filter(columnKey =>
    currentColumnKeySet.has(columnKey)
  );
  const validSavedColumnOrderSet = new Set(validSavedColumnOrder);
  const newlyAddedColumnKeys = currentColumnKeys.filter(
    columnKey => !validSavedColumnOrderSet.has(columnKey)
  );

  return [...validSavedColumnOrder, ...newlyAddedColumnKeys];
}
